import script from "./StepLadder.vue?vue&type=script&setup=true&lang=js"
export * from "./StepLadder.vue?vue&type=script&setup=true&lang=js"

import "./StepLadder.vue?vue&type=style&index=0&id=2579d934&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2579d934"]])

export default __exports__